export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const permissions = vnode.context.$store.getters['user/permissions'] || []
    if (Array.isArray(value)) {
      const has = value.some(code => permissions.includes(code))
      if (!has) el.parentNode && el.parentNode.removeChild(el)
    } else if (typeof value === 'string') {
      if (!permissions.includes(value)) el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
